<div class="progress-buttons">
  <ng-container *ngIf="previousProgress">
    <button mat-raised-button
            class="button-previous"
            [disabled]="!progressChangeable"
            (click)="
              trackProgressChangeStart(previousProgress.id);
              setCurrentProgress(previousProgress.id);
            ">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      <ng-container [ngSwitch]="previousProgress.id">
        <span class="title" translate>i18n.button.back</span>
      </ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="nextProgress">
    <button mat-raised-button
            color="primary"
            class="button-next"
            [disabled]="!progressChangeable"
            validate-design-step
            (validationDone)="setCurrentProgress(nextProgress.id)"
            (validationFailed)="onValidationFailed($event)">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      <ng-container [ngSwitch]="nextProgress.id">
        <span class="title" translate>i18n.button.continue</span>
      </ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="!nextProgress">
    <button mat-raised-button
            validate-design-step
            finalize-design
            [disabled]="!progressChangeable"
            (finalizedDesign)="finalizationDone($event)"
            (validationFailed)="onValidationFailed($event)"
            color="primary"
            class="button-next">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      <span class="title" translate>i18n.button.addToCart</span>
    </button>
  </ng-container>
</div>
